import * as type from '../actions/types';

const initialState = {
  auth: [],
  loading: false,
  error: null,
}

export default function login(state = initialState, action) {
  switch (action.type) {
    case type.POST_LOGIN_REQUESTED:
      return {
        ...state,
        loading: true,
      }
    case type.POST_LOGIN_SUCCESS:
      return {
        ...state,
        loading: false,
        auth: action.auth,
        // error:action.errors
      }
    case type.POST_LOGIN_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      }
    case type.CLEAR_LOGIN_ERROR:
      return {
        ...state,
        error: null,
      }
    default:
      return state
  }
}